
import { Link } from "react-router-dom";

const Footer = () => {
  return <footer className="bg-drcash-maastricht-blue text-white py-12">
      <div className="container mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/">
              <img src="/lovable-uploads/7803889f-eb81-4270-a579-f73831cb8d36.png" alt="Dr.Cash Logo" className="h-12 mb-4" />
            </Link>
            <p className="text-drcash-cadet-gray mb-4">Criamos um conjunto de soluções financeiras para manter seu fluxo de caixa sempre saudável.</p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/drcash.com.br/" target="_blank" rel="noopener noreferrer" className="text-white hover:text-drcash-caribbean-green transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                </svg>
              </a>
              <a href="https://twitter.com/DrCashBR" target="_blank" rel="noopener noreferrer" className="text-white hover:text-drcash-caribbean-green transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z"></path>
                </svg>
              </a>
              <a href="https://www.instagram.com/drcashbr" target="_blank" rel="noopener noreferrer" className="text-white hover:text-drcash-caribbean-green transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                </svg>
              </a>
              <a href="https://br.linkedin.com/company/drcashbr" target="_blank" rel="noopener noreferrer" className="text-white hover:text-drcash-caribbean-green transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                  <rect x="2" y="9" width="4" height="12"></rect>
                  <circle cx="4" cy="4" r="2"></circle>
                </svg>
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-bold mb-4">Soluções</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/boleto-parcelado" className="text-drcash-cadet-gray hover:text-white transition-colors">
                  Boleto Parcelado
                </Link>
              </li>
              <li>
                <Link to="/antecipacao" className="text-drcash-cadet-gray hover:text-white transition-colors">
                  Antecipação de Recebíveis
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-bold mb-4">Links Úteis</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/sobre" className="text-drcash-cadet-gray hover:text-white transition-colors">
                  Sobre Nós
                </Link>
              </li>
              <li>
                <Link to="/atendimento" className="text-drcash-cadet-gray hover:text-white transition-colors">
                  Atendimento
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-drcash-cadet-gray hover:text-white transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/politica-de-privacidade" className="text-drcash-cadet-gray hover:text-white transition-colors">
                  Política de Privacidade
                </Link>
              </li>
              <li>
                <Link to="/termos-de-uso" className="text-drcash-cadet-gray hover:text-white transition-colors">
                  Termos de Uso
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-bold mb-4">Contato</h3>
            <ul className="space-y-2">
              <li className="flex items-start space-x-2">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mt-0.5 text-drcash-caribbean-green" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <a href="mailto:contato@drcash.com.br" className="text-drcash-cadet-gray hover:text-white transition-colors">
                  contato@drcash.com.br
                </a>
              </li>
            </ul>
            <div className="mt-6">
              <Link to="/acesse-portais" className="btn-primary inline-block">
                Acesso Clínicas
              </Link>
            </div>
          </div>
        </div>
        
        <div className="border-t border-drcash-sapphire-blue mt-8 pt-8 text-center text-drcash-cadet-gray">
          <p>&copy; {new Date().getFullYear()} Dr.Cash. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>;
};

export default Footer;
